import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Box, Button, TextField } from '@mui/material';
import queryString from 'query-string';
import * as authenticateActions from '../../actions/authenticateActions';
import { notify } from '../../util/notifications';
import AuthLayout from './AuthLayout';

class ResetPassword extends Component {
    state = { password: '', confPassword: '', submitted: false, saving: false };

    errors = () => {
        const { password, confPassword } = this.state;
        const errors = {};
        if (!password) errors.password = 'Enter a new password';
        if (!confPassword) errors.confPassword = 'Enter the password again';
        else if (password && confPassword !== password) errors.confPassword = "Passwords don't match";
        return errors;
    };

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({ submitted: true });
        if (Object.keys(this.errors()).length > 0) return;
        const value = queryString.parse(this.props.location.search);
        const { dispatch, history } = this.props;
        this.setState({ saving: true });
        dispatch(
            authenticateActions.resetPassword(
                value.userId,
                this.state.password,
                value.token,
                () => {
                    notify.createNotification('success', 'Password changed. Sign in with your new password.', this.props.refNotify);
                    history.push('/');
                },
                () => {
                    this.setState({ saving: false });
                    notify.createNotification('error', "The password couldn't be changed. The link may have expired.", this.props.refNotify);
                }
            )
        );
    };

    render() {
        const { password, confPassword, submitted, saving } = this.state;
        const errors = submitted ? this.errors() : {};
        return (
            <AuthLayout title="Set a new password">
                <Box component="form" noValidate onSubmit={this.handleSubmit} sx={{ display: 'grid', gap: 2 }}>
                    <TextField
                        label="New password"
                        type="password"
                        autoComplete="new-password"
                        autoFocus
                        size="medium"
                        value={password}
                        onChange={(e) => this.setState({ password: e.target.value })}
                        error={Boolean(errors.password)}
                        helperText={errors.password}
                    />
                    <TextField
                        label="Confirm new password"
                        type="password"
                        autoComplete="new-password"
                        size="medium"
                        value={confPassword}
                        onChange={(e) => this.setState({ confPassword: e.target.value })}
                        error={Boolean(errors.confPassword)}
                        helperText={errors.confPassword}
                    />
                    <Button type="submit" variant="contained" size="large" disabled={saving}>
                        {saving ? 'Saving…' : 'Save password'}
                    </Button>
                </Box>
            </AuthLayout>
        );
    }
}

const mapStateToProps = (state) => ({ authInfo: state.authInfo, refNotify: state.refNotify });

export default withRouter(connect(mapStateToProps)(ResetPassword));
